import {jsonMember, jsonObject} from "typedjson";
import {DxBaseUiOptions} from "../../../../dx-page-markup/domain/ui-options/dx-base-ui-options";
import {DxHeadNavigationMenuOptions} from "./dx-head-navigation-menu-options";
import {DxSideNavigationMenuOptions} from "./dx-side-navigation-menu-options";

/**
 * Опции навигатора.
 * @publicApi
 */
@jsonObject
export class DxNavigatorOptions extends DxBaseUiOptions {
  @jsonMember({name: "mode", constructor: String, emitDefaultValue: true, isRequired: false})
  private _mode: string = 'TOP';

  @jsonMember({name: "homeRoute", constructor: String, emitDefaultValue: true, isRequired: false})
  private _homeRoute: string;

  @jsonMember({name: "navigatorRoute", constructor: String, emitDefaultValue: true, isRequired: false})
  private _navigatorRoute: string;

  @jsonMember({name: "defaultRoute", constructor: String, emitDefaultValue: true, isRequired: false})
  private _defaultRoute: string;

  @jsonMember({name: "headNavigationMenuOptions", constructor: DxHeadNavigationMenuOptions, emitDefaultValue: true, isRequired: false})
  private _headNavigationMenuOptions: DxHeadNavigationMenuOptions;

  @jsonMember({name: "sideNavigationMenuOptions", constructor: DxSideNavigationMenuOptions, emitDefaultValue: true, isRequired: false})
  private _sideNavigationMenuOptions: DxSideNavigationMenuOptions;

  get mode(): string {
    return this._mode;
  }

  set mode(value: string) {
    this._mode = value;
  }

  get homeRoute(): string {
    return this._homeRoute;
  }

  set homeRoute(value: string) {
    this._homeRoute = value;
  }

  get navigatorRoute(): string {
    return this._navigatorRoute;
  }

  get headNavigationMenuOptions(): DxHeadNavigationMenuOptions {
    return this._headNavigationMenuOptions;
  }

  get defaultRoute(): string {
    return this._defaultRoute;
  }

  set defaultRoute(value: string) {
    this._defaultRoute = value;
  }

  set headNavigationMenuOptions(value: DxHeadNavigationMenuOptions) {
    this._headNavigationMenuOptions = value;
  }

  get sideNavigationMenuOptions(): DxSideNavigationMenuOptions {
    return this._sideNavigationMenuOptions;
  }

  set sideNavigationMenuOptions(value: DxSideNavigationMenuOptions) {
    this._sideNavigationMenuOptions = value;
  }
}
